import React from 'react';

interface IconProps {
  className?: string;
  style?: React.CSSProperties;
  width?: string | number;
  height?: string | number;
  active?: boolean;
}

const GrundstueckIcon: React.FC<IconProps> = ({
  className,
  style,
  width = 48,
  height = 48,
}) => {
  return (
    <svg
      viewBox="568 335 36 36"
      width={width}
      height={height}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        d="M598 335H574C570.69 335 568 337.69 568 341V365C568 368.31 570.69 371 574 371H598C601.31 371 604 368.31 604 365V341C604 337.69 601.31 335 598 335ZM569 348H579V353H569V348ZM569 365V354H591V370H580V359H579V370H574C571.24 370 569 367.76 569 365ZM603 365C603 367.76 600.76 370 598 370H592V353H580V347H569V341C569 338.24 571.24 336 574 336H591V348H592V336H598C600.76 336 603 338.24 603 341V365Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default GrundstueckIcon;
